import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { Engin } from '@/types';

interface EnginState {
  engins: Engin[];
  pageNum: number;
  totalPages: number;
}

const initialState: EnginState = { engins: [], pageNum: 0, totalPages: 0 };

const enginSlice = createSlice({
  name: 'engin',
  initialState,
  reducers: {
    setEngins(state, action: PayloadAction<Engin[] | { data: Engin[]; pageNum?: number; totalPages?: number }>) {
      const payload = action.payload;
      if (Array.isArray(payload)) {
        state.engins = payload;
        state.pageNum = 0;
        state.totalPages = 0;
      } else {
        state.engins = payload.data ?? [];
        if (payload.pageNum != null) state.pageNum = payload.pageNum;
        if (payload.totalPages != null) state.totalPages = payload.totalPages;
      }
    },
    addEngin(state, action: PayloadAction<Engin>) {
      state.engins.push(action.payload);
    },
    removeEngin(state, action: PayloadAction<Engin>) {
      state.engins = state.engins.filter((e) => e.id !== action.payload.id);
    },
    editEngin(state, action: PayloadAction<Engin>) {
      const i = state.engins.findIndex((e) => e.id === action.payload.id);
      if (i !== -1) state.engins[i] = action.payload;
    },
  },
});

export const { setEngins, addEngin, removeEngin, editEngin } = enginSlice.actions;
export default enginSlice.reducer;
